import { EnumIntegrationStatus } from "@/components/pages/integrations/types";
import type { IntegrationMeta } from "@/components/pages/integrations/composables/types";
import { integrationsMenu } from "@/app/ui/navigation/integrationsMenu";
import img from "@/assets/images/app/integrations/commerce7Logo.png";
import messages from "@/plugins/i18n";

import type { Commerce7Settings } from "@/app/services/generated/commerce7settingsService";
import { commerce7SettingsService } from "@/app/services/generated/commerce7settingsService";
import type { LocalDate } from "@js-joda/core";
import {
  Commerce7OrderFilter,
  commerce7OrderService,
} from "@/app/services/generated/commerce7orderService";
import { fillFilterDates } from "@/store/modules/integrationErrorStore";

export type Commerce7LinkStatus = {
  settings: Commerce7Settings;
  canConnect: boolean;
  status: EnumIntegrationStatus;
};

export async function getCommerce7LinkStatus(): Promise<Commerce7LinkStatus> {
  const settings = await commerce7SettingsService.getCommerce7Settings();
  const tenantChosen = settings && !!settings.tenantName;
  const canConnect =
    tenantChosen && (await commerce7SettingsService.testCommerce7Connection());
  const status =
    tenantChosen && !!settings.outletId
      ? canConnect
        ? EnumIntegrationStatus.active
        : EnumIntegrationStatus.unauthenticated
      : EnumIntegrationStatus.inactive;

  return {
    settings,
    canConnect,
    status,
  };
}

export function commerce7Meta(
  linkStatus: Commerce7LinkStatus | null
): IntegrationMeta {
  return {
    name: messages.commerce7_title,
    description: messages.commerce7_description,
    integrationRoute: integrationsMenu.commerce7.viewLocation(),
    miniImg: img,
    img,
    url: messages.commerce7_url,
    activated: linkStatus?.status.isActive() ?? false,
    status: linkStatus?.status ?? EnumIntegrationStatus.inactive,
  };
}

export async function getCommerce7Orders(
  fromDate?: LocalDate | null,
  toDate?: LocalDate | null
) {
  return (
    await commerce7OrderService.getCommerce7OrdersByFilter(
      fillFilterDates(new Commerce7OrderFilter(), fromDate, toDate)
    )
  ).commerce7Orders;
}
